let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class AuthService {
   constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
      this.$q = $q;
      this.$http = $http;
      this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
      this.ngAuthSettings = ngAuthSettings;
      this.baseURL = ngAuthSettings.apiServiceBaseUri;
   }

   fetchAuthorization(key) {
      return fetch(`${this.baseURL}/api/v1/auth/generate-keys?key=${key}`)
         .then(res => res.json())
   }

   fetchUser(apiToken, userToken) {
      const headers = new Headers({
         'X-Authorization-Token': apiToken,
         'X-User-Token': userToken,
         'X-Origin': 'B2C'
      });

      return fetch(`${this.baseURL}/api/v1/auth/login`, {
            headers,
            method: 'POST',
            mode: 'cors'
         })
         .then(res => res.json())
   }
}

AuthService.$inject = inject;

export default AuthService;


// WEBPACK FOOTER //
// ./www/components/auth/auth.service.js